"use strict";
/*
 * Copyright (C) 2024 Klaus Reimer <k@ailis.de>
 * See LICENSE.md for licensing information.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapOrientation = void 0;
/** Map orientations. */
var MapOrientation;
(function (MapOrientation) {
    MapOrientation["ORTHOGONAL"] = "orthogonal";
    MapOrientation["ISOMETRIC"] = "isometric";
    MapOrientation["STAGGERED"] = "staggered";
    MapOrientation["HEXAGONAL"] = "hexagonal";
})(MapOrientation || (exports.MapOrientation = MapOrientation = {}));
//# sourceMappingURL=MapOrientation.js.map